export const contactsScope = "https://www.googleapis.com/auth/contacts.readonly";
export const googleScope = `openid ${contactsScope}`;
